import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userLoged: null,
    role: null,
    registeredCourses: null,
    course: null,
    courseType: null,
    authorized: "0",
    selectedUser: null
  },
  mutations: {
    setUserLoged(state, payload) {
      state.userLoged = payload
      state.role = payload
    },
    setSelectedUser(state, payload){
      state.selectedUser = payload
    },
    setRole(state, payload){
      state.role = payload
    },
    setCourse(state, payload){
      state.course = payload
    },
    setCourseType(state, payload){
      state.courseType = payload
    },
    setRegisteredCourses(state, payload){
      state.registeredCourses = payload
    },
    setAuthorized(state, payload){
      state.authorized = payload
    },
    logout(state, payload){
      state.userLoged = payload
      state.role = payload
      state.registeredCourses = payload
      state.course = payload
      state.courseType = payload
      state.authorized = "0"
      firebase.auth().signOut();
    }
  },
  actions: {
    setUserLoged({ commit }) {
      commit("setUserLoged", firebase.auth().currentUser)
    },
    setSelectedUser({commit}, payload){
      commit("setSelectedUser", payload)
    },
    setRole({commit}, payload){
      commit("setRole", payload)
    },
    setCourse({commit}, payload){
      commit("setCourse", payload)
    },
    setCourseType({commit}, payload){
      commit("setCourseType", payload)
    },
    setRegisteredCourses({commit}, payload){
      commit("setRegisteredCourses", payload)
    },
    setAuthorized({commit}, payload){
      commit("setAuthorized", payload)
    },
    logout({commit}){
      commit("logout", null)
    }
  },
  getters: {
    getUserLoged: state => {
      return state.userLoged
    },
    getSelectedUser: state =>{
      return state.selectedUser
    },
    getRole: state => {
      return state.role
    },
    getCourse: state => {
      return state.course
    },
    getCourseType: state => {
      return state.courseType
    },
    getRegisteredCourses: state => {
      return state.registeredCourses
    },
    getAuthorized: state =>{
      return state.authorized
    }
  }
})
